// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e4dfc9ac","455":"8e365386","977":"f0196395"}[chunkId] + ".chunk.js";
};